(() => {
  'use strict';

  // Native scrolling and <details> remain usable if JavaScript is unavailable.
  function initFeedback(scope = document) {
    scope.querySelectorAll('[data-premium-feedback]').forEach((section) => {
      if (section.dataset.premiumFeedbackReady) return;
      const track = section.querySelector('[data-premium-review-track]');
      const controls = section.querySelector('[data-premium-review-controls]');
      const previous = section.querySelector('[data-premium-review-prev]');
      const next = section.querySelector('[data-premium-review-next]');
      const status = section.querySelector('[data-premium-review-status]');
      const cards = [...(track?.querySelectorAll('[data-feedback-card]') || [])];
      if (!track || !controls || !previous || !next || !status || !cards.length) return;
      section.dataset.premiumFeedbackReady = 'true';

      let active = 0;
      let frame = 0;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const cardLeft = (card) => card.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
      const update = () => {
        const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        controls.hidden = maxScroll < 4;
        active = cards.reduce((best, card, index) => {
          const distance = Math.abs(track.scrollLeft - Math.min(cardLeft(card), maxScroll));
          return distance < best.distance ? { index, distance } : best;
        }, { index: 0, distance: Infinity }).index;
        if (track.scrollLeft >= maxScroll - 3 && maxScroll > 4) active = cards.length - 1;
        status.textContent = `${active + 1} / ${cards.length}`;
        previous.disabled = track.scrollLeft <= 3;
        next.disabled = track.scrollLeft >= maxScroll - 3;
      };
      const scheduleUpdate = () => {
        window.cancelAnimationFrame(frame);
        frame = window.requestAnimationFrame(update);
      };
      const goTo = (index) => {
        const target = Math.max(0, Math.min(cards.length - 1, index));
        track.scrollTo({ left: cardLeft(cards[target]), behavior: reducedMotion.matches ? 'auto' : 'smooth' });
      };
      previous.addEventListener('click', () => goTo(active - 1));
      next.addEventListener('click', () => goTo(active + 1));
      track.addEventListener('scroll', scheduleUpdate, { passive: true });
      track.addEventListener('keydown', (event) => {
        if (event.target !== track || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
        const targets = { ArrowLeft: active - 1, ArrowRight: active + 1, Home: 0, End: cards.length - 1 };
        if (!Object.prototype.hasOwnProperty.call(targets, event.key)) return;
        event.preventDefault();
        goTo(targets[event.key]);
      });
      const resizeObserver = typeof ResizeObserver === 'function' ? new ResizeObserver(scheduleUpdate) : null;
      resizeObserver?.observe(track);
      if (!resizeObserver) window.addEventListener('resize', scheduleUpdate, { passive: true });
      document.addEventListener('shopify:section:unload', (event) => {
        if (!event.target.contains(section)) return;
        resizeObserver?.disconnect();
        window.cancelAnimationFrame(frame);
        window.removeEventListener('resize', scheduleUpdate);
      });
      update();
    });
  }

  initFeedback();
  document.addEventListener('shopify:section:load', (event) => initFeedback(event.target));
})();
